import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import ActionButton from '@/components/action_button/Index.vue';
import LinkButton from '@/components/link_button/Index.vue';
import ChatbotSettings from '@/views/v3/chatbot_settings/ChatbotSettings.vue';
import PromptManager from '@/views/v3/chatbot_settings/PromptManager.vue';
let TermsAndAgreement = class TermsAndAgreement extends Mixins(ViewportSizeMixin, RouterParamsAppMixin) {
    constructor() {
        super(...arguments);
        this.selectedTab = 'Chatbot Settings';
    }
    tabBuilder() {
        const commonProps = {
            orangeTheme: true,
            flat: true,
            capitalized: true,
        };
        return [
            {
                ...commonProps,
                id: 'chatbot-settings',
                label: 'Chatbot Settings',
            },
            // {
            //   ...commonProps,
            //   id: 'chatbot-training',
            //   label: 'Chatbot Training',
            // },
            {
                ...commonProps,
                id: 'prompt-manager',
                label: 'Prompt Manager',
            },
        ];
    }
    get pageTitle() {
        if (this.selectedTab === 'Prompt Manager') {
            return 'Configure Intents';
        }
        return 'Chatbot Settings';
    }
    checkSelectedTab(label) {
        if (this.selectedTab === label) {
            return true;
        }
        return false;
    }
};
TermsAndAgreement = __decorate([
    Component({
        components: {
            PageTitle,
            ActionButton,
            LinkButton,
            ChatbotSettings,
            PromptManager,
        },
    })
], TermsAndAgreement);
export default TermsAndAgreement;
